/**
 * Canvas size for a full-quality frame capture that keeps the SOURCE video's
 * aspect ratio: the long side is capped at `maxLongSide` and a small source is
 * never upscaled. Returns `null` when the source dimensions are unknown, so
 * the caller can fall back to its fixed canvas size.
 */
export function fitCanvasToSource({
  sourceWidth,
  sourceHeight,
  maxLongSide,
}: {
  sourceWidth: number;
  sourceHeight: number;
  maxLongSide: number;
}): { width: number; height: number } | null {
  if (!Number.isFinite(sourceWidth) || !Number.isFinite(sourceHeight)) return null;
  if (sourceWidth <= 0 || sourceHeight <= 0) return null;
  const scale = Math.min(1, maxLongSide / Math.max(sourceWidth, sourceHeight));
  return {
    width: Math.max(1, Math.round(sourceWidth * scale)),
    height: Math.max(1, Math.round(sourceHeight * scale)),
  };
}
